/**
 * iKSORIS - WWW
 * SoftCOM Spółka jawna - http://www.softcom.wroc.pl
 * @author SoftCOM Spółka jawna <biuro@softcom.wroc.pl>
 * @copyright Copyright (c) 2010-2014, SoftCOM Spółka jawna
 */

import { Tools } from "../utilities/Tools";
import { Ajax } from "../core/Ajax";

class Dialog {
    constructor(toggle = null, settings = {}) {
        this.toggle = toggle;
        this.config = {
            dialogAjax: false, // boolean
            dialogHeader: "", // string
            dialogBody: "", // string (HTML)
            dialogFullscreen: "", // modal-fullscreen (Always), modal-fullscreen-sm-down (Below 576px), modal-fullscreen-md-down (Below 768px), modal-fullscreen-lg-down (Below 992px), modal-fullscreen-xl-down (Below 1200px), modal-fullscreen-xxl-down
            dialogScrollingLongContent: false, // boolean
            dialogSize: "", // modal-sm (Small 300px), '' (Default 500px), modal-lg (Large 800px), modal-xl (Extra large 1140px), modal-xl (Extra extra large 1780px)
            dialogVerticallyCentered: false, // boolean
            dialogBeforeFunction: function () {
                return new Promise((resolve, reject) => {
                    resolve(true);
                });
            }, // function
            dialogAfterFunction: undefined, // function
            dialogShowFunction: undefined, // function
            dialogShownFunction: undefined, // function
            dialogHideFunction: undefined, // function
            dialogHiddenFunction: undefined, // function
            dialogButtons: {}, // object
            //{
            //  "button 1": function(event) {},
            //  "button 2": function(event) {},
            //}
        };
        this._settings = Object.assign(
            this.config,
            this.toggle ? this.toggle.dataset : {},
            Tools.parseStringValuesInObjectLiteral(settings)
        );
        this.id = "dialog";
        this.bootstrapModal = undefined;

        // Stworzenie nowej funkcji z nowo przypisanym this na potrzeby dodawania i usuwania zadarzeń
        this.modalBodyEventBind = this.modalBodyEvent.bind(this);

        //
        this.init();
    }

    get settings() {
        return this._settings;
    }

    set settings(value) {
        this._settings = value;
    }

    get getDialogHeader() {
        return this._settings.dialogHeader;
    }

    set setDialogHeader(value) {
        if (!Boolean(this.bootstrapModal)) {
            throw new Error("Nie można zmienić modal-header w oknie dialog, które jest nieaktywne!");
        }

        this._settings.dialogHeader = value;

        // Zaaktualizowanie modal-header.
        this.renderDialogHeader();
    }

    get getDialogBody() {
        return this._settings.dialogBody;
    }

    set setDialogBody(value) {
        if (!Boolean(this.bootstrapModal)) {
            throw new Error("Nie można zmienić modal-body w oknie dialog, które jest nieaktywne!");
        }

        this._settings.dialogBody = value;

        // Zaaktualizowanie modal-body.
        this.renderDialogBody();
    }

    get getDialogBeforeFunction() {
        return this._settings.dialogBeforeFunction;
    }

    set setDialogBeforeFunction(value) {
        this._settings.dialogBeforeFunction = value;
    }

    events() {
        const _this = this;

        this.toggle.addEventListener("click", function (event) {
            event.preventDefault();

            _this.renderDialog();
        });
    }

    modalBodyEvent(event) {
        // Wykluczone sekecje (wszystkie te elementy, które po kliknięciu mają zachować się w sposób domyślny).
        if (
            Boolean(event.target.closest(".ui-tabs")) ||
            Boolean(event.target.closest(".cke")) ||
            Boolean(event.target.closest(".save-as-collapse"))
        ) {
            return false;
        }

        //
        switch (event.type) {
            case "click":
                // Tag a
                let aTag = event.target.closest("a");

                if (Boolean(aTag)) {
                    if (Boolean(aTag.dataset.preventDialog)) {
                        return true;
                    }

                    event.preventDefault();

                    //Wysłanie żądania Ajax
                    Ajax.sendAjaxRequest(
                        aTag.getAttribute("href"),
                        {
                            method: "GET",
                            headers: {
                                "X-Requested-With": "XMLHttpRequest",
                            },
                        },
                        "String"
                    )
                        .then((html) => {
                            // Dodanie html do .modal-body
                            this.setDialogBody = html;
                        })
                        .catch((e) => console.log(e));
                }

                // Tag input[type="submit"]
                let submitTag = event.target.closest('[type="submit"]');

                if (Boolean(submitTag)) {
                    if (Boolean(submitTag.dataset.preventDialog)) {
                        return true;
                    }

                    if (jQuery(submitTag.form).validate().form()) {
                        event.preventDefault();

                        switch (submitTag.form.getAttribute("method")) {
                            case "get":
                                let form = submitTag.form;
                                let url = form.action;

                                // Pobieranie danych z pól formularza.
                                let data = new FormData(form);

                                // Konwertoanie na ciąg zapytania.
                                let queryString = new URLSearchParams(data).toString();

                                //Wysłanie żądania Ajax
                                Ajax.sendAjaxRequest(
                                    url + "&" + queryString + "&" + submitTag.name + "=" + submitTag.value,
                                    {
                                        method: "GET",
                                        headers: {
                                            "X-Requested-With": "XMLHttpRequest",
                                        },
                                    },
                                    "String"
                                )
                                    .then((html) => {
                                        // Dodanie html do .modal-body
                                        this.setDialogBody = html;
                                    })
                                    .catch((e) => console.log(e));
                                break;

                            case "post":
                                //Wysłanie żądania Ajax
                                Ajax.sendAjaxRequest(
                                    jQuery(submitTag.form).attr("action"),
                                    {
                                        method: "POST",
                                        headers: {
                                            "Content-type": "application/x-www-form-urlencoded",
                                            "X-Requested-With": "XMLHttpRequest",
                                        },
                                        body:
                                            jQuery(submitTag.form).serialize() +
                                            "&" +
                                            submitTag.name +
                                            "=" +
                                            submitTag.value,
                                    },
                                    "String"
                                )
                                    .then((html) => {
                                        // Dodanie html do .modal-body
                                        this.setDialogBody = html;
                                    })
                                    .catch((e) => console.log(e));

                                break;
                        }
                    }
                }

                // Tag input[type="button"]
                let buttonTag = event.target.closest('[type="button"]');

                if (Boolean(buttonTag)) {
                    if (Boolean(buttonTag.dataset.preventDialog)) {
                        return true;
                    }

                    event.preventDefault();

                    if (Boolean(buttonTag.dataset.href)) {
                        //Wysłanie żądania Ajax
                        Ajax.sendAjaxRequest(
                            buttonTag.dataset.href,
                            {
                                method: "GET",
                                headers: {
                                    "X-Requested-With": "XMLHttpRequest",
                                },
                            },
                            "String"
                        )
                            .then((html) => {
                                // Dodanie html do .modal-body
                                this.setDialogBody = html;
                            })
                            .catch((e) => console.log(e));
                    }
                }

                break;

            case "change":
                // Tag select
                let select = event.target.closest("#collapse-toolbar select");

                if (Boolean(select)) {
                    let form = select.form;
                    let formAction = form.action;
                    let formData = new FormData(form);
                    let formParams = new URLSearchParams(formData).toString();

                    //Wysłanie żądania Ajax
                    Ajax.sendAjaxRequest(
                        `${formAction}?${formParams}`,
                        {
                            method: "GET",
                            headers: {
                                "X-Requested-With": "XMLHttpRequest",
                            },
                        },
                        "String"
                    )
                        .then((html) => {
                            // Dodanie html do .modal-body
                            this.setDialogBody = html;
                        })
                        .catch((e) => console.log(e));
                }

                break;

            default:
                break;
        }
    }

    initBootstrapModalEvents() {
        const _this = this;

        // To zdarzenie jest wywoływane natychmiast po wywołaniu metody instancji show.
        document.getElementById(this.id).addEventListener("show.bs.modal", function (event) {
            if (Boolean(_this.settings.dialogShowFunction) && typeof _this.settings.dialogShowFunction === "function") {
                _this.settings.dialogShowFunction();
            }
        });

        // To zdarzenie jest wywoływane, gdy modal jest widoczny dla użytkownika (będzie czekał na zakończenie przejść CSS).
        document.getElementById(this.id).addEventListener("shown.bs.modal", function (event) {
            if (
                Boolean(_this.settings.dialogShownFunction) &&
                typeof _this.settings.dialogShownFunction === "function"
            ) {
                _this.settings.dialogShownFunction();
            }
        });

        // To zdarzenie jest wywoływane natychmiast po wywołaniu metody hide.
        document.getElementById(this.id).addEventListener("hide.bs.modal", function (event) {
            if (Boolean(_this.settings.dialogHideFunction) && typeof _this.settings.dialogHideFunction === "function") {
                _this.settings.dialogHideFunction();
            }
        });

        // To zdarzenie jest wywoływane, gdy modal przestanie być ukrywany przed użytkownikiem (będzie czekał na zakończenie przejść CSS).
        document.getElementById(this.id).addEventListener("hidden.bs.modal", function (event) {
            if (
                Boolean(_this.settings.dialogHiddenFunction) &&
                typeof _this.settings.dialogHiddenFunction === "function"
            ) {
                _this.settings.dialogHiddenFunction();
            }

            // Niszczy instancje CKEDITOR'A
            _this.destroyCKEDITORInstances();

            // Niszczy modal. Usuwa dane zapisane w elemencie DOM.
            _this.destroyBootstrapModal();

            // Ustawienie Datepicker Widget dla pól wyboru daty poza oknem dialog.
            jQuery("input.form-field-date").datepicker();
        });
    }

    createBootstrapModalInstance() {
        this.bootstrapModal = new bootstrap.Modal(document.getElementById(this.id));
        this.initBootstrapModalEvents();
    }

    modalHeaderTemplate() {
        return `
                <h5 class="modal-title" id="${this.id}Label">${this.getDialogHeader}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Zamknij"></button>
        `;
    }

    modalBodyTemplate() {
        return this.getDialogBody;
    }

    modalFooterTemplate() {
        return `${(function ({ dialogButtons }) {
            if (Object.keys(dialogButtons).length > 0) {
                let buttons = "";

                for (const key in dialogButtons) {
                    if (Object.hasOwnProperty.call(dialogButtons, key)) {
                        const button = dialogButtons[key];

                        buttons += `<button type="button" class="btn btn-primary" data-dialog-button-key="${key}">${key}</button>`;
                    }
                }

                return buttons;
            } else {
                return "";
            }
        })(this.settings)}`;
    }

    modalTemplate() {
        const _this = this;

        return `<div class="dialog modal fade" id="${this.id}" tabindex="-1" aria-labelledby="${
            this.id
        }Label" aria-hidden="true">
                    <div class="modal-dialog ${(function () {
                        return [
                            _this.settings.dialogFullscreen,
                            _this.settings.dialogScrollingLongContent ? "" : "modal-dialog-scrollable",
                            _this.settings.dialogSize,
                            _this.settings.dialogVerticallyCentered ? "modal-dialog-centered" : "",
                        ].join(" ");
                    })()}">
                        <div class="modal-content">
                            <div class="modal-header"></div>
                            <div class="modal-body"></div>
                            <div class="modal-footer"></div>
                        </div>
                    </div>
                </div>`;
    }

    renderDialogHeader() {
        document.getElementById(this.id).querySelector(".modal-header").innerHTML = this.modalHeaderTemplate();
    }

    renderDialogBody() {
        document.getElementById(this.id).querySelector(".modal-body").innerHTML = this.modalBodyTemplate().replace(
            /<script\b[^>]*>([\s\S]*?)<\/script>/gm,
            ""
        );

        // Usuwanie eventów dla .modal-body
        document.querySelector(".modal-body").removeEventListener("click", this.modalBodyEventBind, false);
        document.querySelector(".modal-body").removeEventListener("change", this.modalBodyEventBind, false);

        // Dodanie eventów dla .modal-body
        document.querySelector(".modal-body").addEventListener("click", this.modalBodyEventBind, false);
        document.querySelector(".modal-body").addEventListener("change", this.modalBodyEventBind, false);

        // Ładowanie skryptów ze stringa (HTML)
        Tools.loadScriptsDynamically(this.modalBodyTemplate());

        // Ponowne przeszukanie elementów (sekektor [data-toggle]) i utworzenie na ich podstawie instancji.
        iksoris.reloadInstances();

        // Po wyrenderowaniu nowego widoku dla .modal-body przewijamy sekcję do góry.
        Tools.scrollTo(document.getElementById(this.id).querySelector(".modal-body"), 0);
    }

    renderDialogFooter() {
        document.getElementById(this.id).querySelector(".modal-footer").innerHTML = this.modalFooterTemplate();

        // Dodanie eventów dla utworzonych przycisków
        const { dialogButtons } = this.settings;

        if (Object.keys(dialogButtons).length > 0) {
            for (const key in dialogButtons) {
                if (Object.hasOwnProperty.call(dialogButtons, key)) {
                    const buttonFunction = dialogButtons[key];

                    document
                        .querySelector('[data-dialog-button-key="' + key + '"]')
                        .addEventListener("click", buttonFunction);
                }
            }
        }
    }

    renderDialog() {
        const _this = this;

        document.querySelector("body").insertAdjacentHTML(
            "beforeend",
            (function () {
                return _this.modalTemplate();
            })()
        );

        // Dodanie instancji dialog dla elementu #dialog.
        document.getElementById(this.id).instance = this;

        // Stworzenie instancji bootstrap'owego modala.
        this.createBootstrapModalInstance();

        this.renderDialogHeader();
        this.renderDialogBody();
        this.renderDialogFooter();

        // Wywołanie zdarzenia before.dialog w celu wywołania setDialogBeforeFunction().
        _this.toggle.dispatchEvent(
            new CustomEvent("beforefunctiondialog", {
                bubbles: true,
                detail: {
                    element: _this.toggle,
                    dialog: _this,
                },
            })
        );

        //
        (async function () {
            let resultDialogBeforeFunction = await _this.getDialogBeforeFunction();

            if (resultDialogBeforeFunction) {
                //
                if (_this.settings.dialogAjax) {
                    _this.setDialogHeader = _this.toggle.title;

                    //Wysłanie żądania Ajax
                    Ajax.sendAjaxRequest(
                        _this.toggle.getAttribute("href"),
                        {
                            headers: {
                                "X-Requested-With": "XMLHttpRequest",
                            },
                        },
                        "String"
                    )
                        .then((html) => {
                            // Dodanie html do .modal-body
                            _this.setDialogBody = html;

                            // Otworzenie modala.
                            _this.bootstrapModal.show();
                        })
                        .catch((e) => console.log(e));

                    return false;
                }

                // Otworzenie modala.
                _this.bootstrapModal.show();
            } else {
                _this.destroyBootstrapModal();
            }
        })();
    }

    destroyBootstrapModal() {
        // Niszczy modal. Usuwa dane zapisane w elemencie DOM.
        this.bootstrapModal.dispose();
        this.bootstrapModal = undefined;

        // Usuwa dialog. Usuwa dane zapisane w elemencie DOM.
        this.removeDialog();
    }

    // Usunięcie instancji CKEDITOR powiązanych z polami formularza, które pojawiały się w oknie dialog.
    destroyCKEDITORInstances() {
        const _this = this;

        jQuery.each(CKEDITOR.instances, function (index, instance) {
            if (
                instance.element.$.form.id ===
                document.getElementById(_this.id).querySelector("form").getAttribute("id")
            ) {
                CKEDITOR.instances[instance.name].destroy(true);
            }
        });
    }

    removeDialog() {
        document.getElementById(this.id).remove();
    }

    show(settings = {}) {
        if (Boolean(this.bootstrapModal)) {
            throw new Error("Modal jest już otwarty!");
        }

        this.settings = Object.assign(this.config, Tools.parseStringValuesInObjectLiteral(settings));
        this.renderDialog();
    }

    hide() {
        if (!Boolean(this.bootstrapModal)) {
            throw new Error("Modal nie jest otwarty!");
        }

        // Zamknięcie modala.
        this.bootstrapModal.hide();
    }

    init() {
        if (Boolean(this.toggle)) {
            // Utworzenie Map
            window.iksoris.instances = window.iksoris.instances || new Map();

            if (Boolean(window.iksoris.instances.get(this.toggle))) {
                return false;
            }

            window.iksoris.instances.set(this.toggle, this);

            // Inicjalizacja eventów
            this.events();
        }
    }
}

export { Dialog };
